export default __webpack_public_path__ + "static/media/0074.748f87e4.jpg";